import styles from './DroneWarning.module.css';
import { useIntl } from 'react-intl';

export default function DroneWarning() {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <span>⚠️</span>
      <div className={styles.text}>
        <div
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'DroneWarning.titleAndDescription' }),
          }}
        />
      </div>
    </div>
  );
}

//add break depsues de requoeren

// button para testimional
